import React from "react";
import Weather from "./Weather";
import "./App.css"
export default function App() {
  return (
    <div className="App">
     <Weather defaultCity="Los Angeles" />
     <footer>This project was coded by <a href="https://www.linkedin.com/in/maryam-akhlaghi-03158276" target="_blank" rel="noreferrer" >Maryam Akhlaghi</a> and is <a href="https://github.com/Maryam-akhlaghi/react-weather-app" target="_blank" rel="noreferrer">Open-sourced on GitHub</a></footer>
    </div>
  );
}
